import * as React from 'react';

const Exclamation = () => (
  <svg width="1.5em" height="1.5em" viewBox="0 0 584 584" fill="none">
    <path
      d="M292 401.5a9.124 9.124 0 100 18.248 9.124 9.124 0 000-18.248z"
      strokeWidth={30}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M292 328.5V127.75"
      strokeWidth={30}
      strokeLinecap="round"
    />
    <path
      d="M18.25 292A273.753 273.753 0 00292 565.75a273.753 273.753 0 00193.571-80.179 273.753 273.753 0 000-387.142 273.753 273.753 0 00-387.142 0A273.75 273.75 0 0018.25 292v0z"
      strokeWidth={30}
    />
  </svg>
);

const MemoExclamation = React.memo(Exclamation);
export default MemoExclamation;
